"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactAddonsCssTransitionGroup = _interopRequireDefault(require("react-addons-css-transition-group"));

var _Notification = _interopRequireDefault(require("./Notification"));

var _useNotifications2 = _interopRequireDefault(require("./useNotifications"));

var NotificationsWrapper = function NotificationsWrapper(_ref) {
  var alias = _ref.alias,
      elementChar = _ref.elementChar,
      modifierChar = _ref.modifierChar,
      children = _ref.children,
      position = _ref.position,
      align = _ref.align;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: alias + " " + alias + modifierChar + position + modifierChar + align
  }, children);
};

NotificationsWrapper.propTypes = {
  alias: _propTypes.default.string,
  elementChar: _propTypes.default.string,
  modifierChar: _propTypes.default.string,
  position: _propTypes.default.oneOf(['top', 'left', 'bottom', 'right']),
  align: _propTypes.default.oneOf(['start', 'center', 'end']),
  children: _propTypes.default.node
};
NotificationsWrapper.defaultProps = {
  alias: 'NotificationsWrapper',
  elementChar: '_',
  modifierChar: '___'
};

var NotificationsHandler = function NotificationsHandler(_ref2) {
  var alias = _ref2.alias,
      elementChar = _ref2.elementChar,
      modifierChar = _ref2.modifierChar;

  var _useNotifications = (0, _useNotifications2.default)(),
      notifications = _useNotifications.notifications,
      closeNotificationById = _useNotifications.closeNotificationById,
      statusTypes = _useNotifications.statusTypes,
      position = _useNotifications.position,
      align = _useNotifications.align;

  return /*#__PURE__*/_react.default.createElement(_reactAddonsCssTransitionGroup.default, {
    transitionName: "Notification",
    transitionEnterTimeout: 300,
    transitionLeaveTimeout: 300,
    component: NotificationsWrapper,
    position: position,
    align: align
  }, Object.values(notifications).filter(function (_ref3) {
    var status = _ref3.status;
    return status !== statusTypes.HIDDEN;
  }).map(function (notification) {
    return /*#__PURE__*/_react.default.createElement(_Notification.default, (0, _extends2.default)({
      key: notification.id,
      onClose: function onClose() {
        return closeNotificationById(notification.id);
      }
    }, notification));
  }));
};

NotificationsHandler.propTypes = {
  alias: _propTypes.default.string,
  elementChar: _propTypes.default.string,
  modifierChar: _propTypes.default.string,
  position: _propTypes.default.oneOf(['top', 'left', 'bottom', 'right']),
  align: _propTypes.default.oneOf(['start', 'center', 'end'])
};
NotificationsHandler.defaultProps = {
  alias: 'Notifications',
  elementChar: '_',
  modifierChar: '___'
};
var _default = NotificationsHandler;
exports.default = _default;